module.exports = __webpack_public_path__ + "img/projects-selected.00c2d2e0.svg";